module.exports = __webpack_public_path__ + "static/img/female-bg-en.fab30522.png";